const binding = { modules: {}, dataActions: {} };

    (binding.modules['mfrm-android-banner'] = {
        c: () => require('partner/modules/mfrm-android-banner/mfrm-android-banner.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'mfrm-android-banner',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/mfrm-android-banner'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|mfrm-android-banner|mfrm-android-banner'] = {
                c: () => require('partner/modules/mfrm-android-banner/mfrm-android-banner.view.tsx'),
                cn: '__local__-__local__-mfrm-android-banner'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };